import { format } from "date-fns-tz";

const clientTimeFormat = "yyyy-MM-dd'T'HH:mm:ss.SSSXX";

export const getClientTime = (): string => format(new Date(), clientTimeFormat);
